import { render } from "./EventDeleteDrawer.vue?vue&type=template&id=acf48cc0&scoped=true"
import script from "./EventDeleteDrawer.vue?vue&type=script&lang=js"
export * from "./EventDeleteDrawer.vue?vue&type=script&lang=js"

import "./EventDeleteDrawer.vue?vue&type=style&index=0&id=acf48cc0&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-acf48cc0"]])

export default __exports__